import React from "react";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useScheduledMessages } from "./ScheduledMessagesContext";

const plural = (count, word) => `${count} ${word}${count === 1 ? "" : "s"}`;

// Above the composer: "2 scheduled messages in this conversation. See all"
export default function ScheduledMessagesBanner({ channel }) {
  const scheduled = useScheduledMessages();
  const counts = scheduled?.countsByChannel?.[channel?.cid];
  if (!counts || (!counts.pending && !counts.failed)) return null;

  const failed = counts.failed > 0;
  const Icon = failed ? ErrorOutlineIcon : ScheduleIcon;
  const text = failed
    ? `${plural(counts.failed, "scheduled message")} ${counts.failed === 1 ? "wasn't" : "weren't"} sent.`
    : `${plural(counts.pending, "scheduled message")} in this conversation.`;

  return (
    <div
      className={`mx-3 mb-1 mt-1 flex items-center gap-x-2 rounded-lg px-3 py-1.5 text-sm ${
        failed ? "bg-red-50 text-red-700" : "bg-slate-50 text-slate-600"
      }`}
    >
      <Icon style={{ fontSize: 16 }} />
      <span>{text}</span>
      <button
        type="button"
        className="font-medium text-violet-700 hover:underline"
        onClick={() => scheduled.openList?.()}
      >
        See all scheduled messages
      </button>
    </div>
  );
}
